import { Box, Link } from '@mui/material';
import { sortBy, uniqBy } from 'lodash-es';
import { useMemo } from 'react';
import { SimpleTable } from '../../../components/table/SimpleTable';
import { DownloadLink } from './DownloadLink';
import { useFeatureFlag } from '../../../hooks/use-feature-flag';

export function Boundaries({ rawFiles }) {
  const isUseLeaf = useFeatureFlag('UseLeaf');
  const boundaries = useMemo(
    () =>
      uniqBy(
        (rawFiles || []).flatMap((file) => file.boundaries),
        (f) => f.aaid + f.crop,
      ),
    [rawFiles],
  );

  return boundaries?.length ? (
    <Box>
      <SimpleTable
        rows={sortBy(boundaries, 'fieldName').map((boundary) => {
          const filePrefix = `${boundary.growerName}-${boundary.fieldName}-${boundary.type}-${boundary.year}-${boundary.crop}`;
          return {
            Field: (
              <Link href={boundary.tfsLink} color="inherit" target="_blank">
                {boundary.fieldName}
              </Link>
            ),
            Crop: boundary.crop,
            Year: boundary.year,
            Coverage: boundary.coverage,
            Raw: (
              <DownloadLink
                url={boundary.rawFile}
                displayName={`Raw Points`}
                downloadFilename={`${filePrefix}-raw.csv`}
              />
            ),
            Clean: (
              <DownloadLink
                url={boundary.cleanFile}
                displayName={`Clean Points`}
                downloadFilename={`${filePrefix}-clean.csv`}
              />
            ),
            ...(!isUseLeaf && {
              'Leaf Raw': (
                <DownloadLink
                  url={boundary.leafRawFile}
                  displayName={`Leaf Raw Points`}
                  downloadFilename={`${filePrefix}-leaf-raw.csv`}
                />
              ),
              'Leaf Clean': (
                <DownloadLink
                  url={boundary.leafCleanFile}
                  displayName={`Leaf Clean Points`}
                  downloadFilename={`${filePrefix}-leaf-clean.csv`}
                />
              ),
            }),
          };
        })}
        sx={{
          maxHeight: 300,
          overflow: 'auto',
          '& .MuiTableCell-root': {
            py: 0.5,
            px: 1,
            fontSize: '0.875rem',
          },
          '& .MuiTableHead-root': {
            position: 'sticky',
            top: 0,
            backgroundColor: 'background.paper',
            zIndex: 1,
          },
        }}
      />
    </Box>
  ) : null;
}
